<script lang="ts">
  import Text from '../Text.svelte';

  export let label: string;
  export let description: string;
  export let options: { label: string; value: string }[] = [];
  export let selected: string;
  export let name: string = '';

  const handleChange = (value: string) => {
    selected = value;
    // Dispatch a custom event when the radio button changes
    const event = new CustomEvent('change', { detail: { value } });
    dispatchEvent(event);
  };
</script>

<fieldset class="radio-group-wrapper">
  <Text tagName="legend" size="medium" for={label}>{label}:</Text>
  <div class="radio-group">
    {#each options as { label, value }}
      <label>
        <input
          type="radio"
          bind:group={selected}
          {name}
          {value}
          on:change={() => handleChange(value)}
          checked={selected === value}
        />
        {label}
      </label>
    {/each}
  </div>
  <Text tagName="span" size="small" color="tertiary">
    {description}
  </Text>
</fieldset>

<style lang="scss">
  @use '../../styles/spacing';

  .radio-group-wrapper {
    display: flex;
    flex-direction: column;
    gap: spacing.$xxs;
  }

  .radio-group {
    display: flex;
    flex-direction: row;
  }
</style>
